export const MenuItems = [
  {
    title: 'Create Test',
    path: '/CreateTest',
    cName: 'dropdown-link'
  },
  {
    title: 'Dashboard',
    path: '/Dashboard',
    cName: 'dropdown-link'
  },
  {
    title: 'Chat Bot',
    path: '/chatBot',
    cName: 'dropdown-link'
  },
  {
    title: 'RestMan Studio',
    path: '/RestManStudio',
    cName: 'dropdown-link'
  },
  {
    title: 'RestMan Environments',
    path: '/RestManStudioEnvironments',
    cName: 'dropdown-link'
  }
  // {
  //   title: 'RestApiTest',
  //   path: '/RestApiTest',
  //   cName: 'dropdown-link'
  // }
];
